import React from 'react';
import SkeletonListing from './skeleton/SkeletonListing';

const TableComponent = ({
  tableConfig,
  isListLoader,
  isList,
  redirectTo,
  expandedRowRender,
  isDividend,
}) => {
  if (!tableConfig) {
    throw new Error('tableConfig is undefined or null');
  }

  const { columns, data } = tableConfig;

  const handleRowClick = (id) => {
    if (redirectTo) {
      redirectTo(id);
    }
  };

  return (
    <>
      <table className="tableradus table-auto w-full text-sm text-left border-separate border-spacing-y-3 shadow-none">
        <thead className="text-xs uppercase sr-only">
          <tr>
            <th scope="col" className="px-6 py-3" width="40px">
              #
            </th>
            {Object.keys(columns).map((columnKey, index) => {
              const column = columns[columnKey];
              return (
                <th key={index} scope="col" className="px-6 py-3">
                  {column.title}
                </th>
              );
            })}
          </tr>
        </thead>

        {isListLoader && (
          <SkeletonListing
            columnCount={Object.keys(columns).length + 1}
            rowCount={7}
          />
        )}
        {isList && isList?.length > 0 && isListLoader === false && (
          <tbody>
            {data.map((element, index) => (
              <React.Fragment key={index}>
                <tr
                  className="bg-white border-b mb-3 cursor-pointer"
                  onClick={() => {
                    handleRowClick(element?.id || element?.userData?.id);
                  }}
                >
                  <td className="px-6 py-4 font-medium text-gray-900">
                    {element.id ||
                      element?.projectDetail?.id ||
                      element?.userData?.id ||
                      index + 1 ||
                      'NA'}
                  </td>
                  {Object.keys(columns).map((columnKey) => {
                    const column = columns[columnKey];
                    const cellData = element;

                    const renderContent = () => {
                      if (column.render) {
                        return column.render(cellData, index);
                      }
                      return cellData[columnKey] || 'NA';
                    };

                    return (
                      <td key={columnKey} className="px-6 py-4 text-gray-900">
                        {renderContent()}
                      </td>
                    );
                  })}
                </tr>

                {/* Expanded Row */}
                {expandedRowRender &&
                  isDividend.index === index &&
                  isDividend.status && (
                    <tr>
                      <td
                        colSpan={Object.keys(columns).length + 1}
                        className="bg-gray-100"
                      >
                        {expandedRowRender(element, index)}{' '}
                      </td>
                    </tr>
                  )}
              </React.Fragment>
            ))}
          </tbody>
        )}
      </table>
    </>
  );
};

export default TableComponent;
